/* PavCon, LLC Proprietary.All rights reserved 2022 */

import { Route, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { AppRoles } from 'src/app/app-roles';
import { AuthLevel } from '../domain/enums/authorization-levels.enum';
import { AppInitializationService } from '../services/app-initialization.service';
import CognitoService from '../services/cognito';

@Injectable()
export class AuthLazyGuard {
  constructor(
    private router: Router,
    private app: AppRoles,
    private appInitService: AppInitializationService,
    private authService: CognitoService
  ) {}

  canLoad(route: Route): boolean {
    if (!this.appInitService.isAppInitialized()) {
      this.router.navigateByUrl('/auth/login');
      return false;
    }

    const sessionUser = this.appInitService.getSessionUser();

    if (!sessionUser) {
      this.router.navigateByUrl('/auth/login');
      return false;
    }

    const authorization = this.app.isUserAuthorized(sessionUser);

    if (authorization === AuthLevel.UndefinedAuth) {
      this.authService.globalSignOut();
      this.router.navigateByUrl('/auth/login');
      return false;
    }
    return authorization === AuthLevel.Authorized || authorization === AuthLevel.Unauthorized;
  }
}
